var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFitness(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 18 10' }, props),
        React.createElement("path", { d: 'M3.336-.015c-.847 0-1.533.686-1.533 1.532v6.798a1.533 1.533 0 103.066 0V1.517c0-.846-.687-1.532-1.533-1.532zm0 .8c.404 0 .733.328.733.732v6.798a.733.733 0 01-1.466 0V1.517c0-.404.328-.732.733-.732z' }),
        React.createElement("path", { d: 'M2.203 2.25h-.01a1.9 1.9 0 00-1.9 1.9v1.532a1.9 1.9 0 001.75 1.894l.16.006a.4.4 0 00.4-.4V2.65a.4.4 0 00-.4-.4zm-.4.872V6.71l-.065-.026a1.1 1.1 0 01-.646-1.002V4.15a1.1 1.1 0 01.646-1.002l.064-.026zm13.994-.872h.01a1.9 1.9 0 011.9 1.9v1.532a1.9 1.9 0 01-1.75 1.894l-.16.006a.4.4 0 01-.4-.4V2.65c0-.22.18-.4.4-.4zm.4.872V6.71l.065-.026a1.1 1.1 0 00.646-1.002V4.15a1.1 1.1 0 00-.646-1.002l-.064-.026z' }),
        React.createElement("path", { d: 'M14.664-.015c-.846 0-1.533.686-1.533 1.532v6.798a1.533 1.533 0 003.066 0V1.517c0-.846-.686-1.532-1.533-1.532zm0 .8c.405 0 .733.328.733.732v6.798a.733.733 0 11-1.466 0V1.517c0-.404.329-.732.733-.732z' }),
        React.createElement("path", { d: 'M13.22 5.724a.4.4 0 01.08.792l-.08.008H4.47a.4.4 0 01-.081-.791l.08-.009h8.752zm.311-2.38a.4.4 0 01.081.792l-.08.008H4.923a.4.4 0 01-.081-.792l.08-.008h8.608z' })));
}
export default SvgFitness;
//# sourceMappingURL=Fitness.js.map